import { ConfigTotemMeep } from "../../../repositories/api/ConfigTotemMeep";

/**
 * Dados que a casca CefSharp (C#) lê nos serviços de impressão e de TEF.
 * As chaves seguem as propriedades de `AppConfigurationData` na casca.
 */
export interface HostConfig {
  PrintType: number;
  TicketNote?: string;
  TickectName?: string;
  UserAgent?: string;
  SoftExpressToken?: string;
  SoftExpressCnpj?: string;
  SoftExpressStoreCode?: string;
  SoftExpressCnpjMeepSub?: string;
  SoftExpressStoreCodeMeepSub?: string;
  SoftExpressIsPagSeguroSubAcquirer?: boolean;
  SoftExpressOwnerName?: string;
  SoftExpressOwnerAddress?: string;
  SoftExpressOwnerCity?: string;
  SoftExpressOwnerUf?: string;
  SoftExpressOwnerCountry?: string;
  SoftExpressOwnerZipCode?: string;
  SoftExpressOwnerMcc?: string;
  SoftExpressOwnerCnpjCpf?: string;
  SoftExpressOwnerTelephone?: string;
  SoftExpressOwnerMerchantId?: string;
  SoftExpressOwnerFullName?: string;
  SoftExpressOwnerDocType?: string;
  SoftExpressOwnerFacilitatorMerchantId?: string;
}

const DEFAULT_PRINT_TYPE = 1;

export const toHostConfig = (response: ConfigTotemMeep): HostConfig => {
  const owner = response.softExpressPagSeguroSubAcquirerData;

  return {
    PrintType: response.tipoImpressao || DEFAULT_PRINT_TYPE,
    TicketNote: response.observacaoFicha,
    TickectName: response.localNome,
    UserAgent: response.usuarioMeepPOSApelido,
    SoftExpressToken: response.softExpressToken,
    SoftExpressCnpj: response.softExpressCnpj,
    SoftExpressStoreCode: response.softExpressStoreCode,
    SoftExpressCnpjMeepSub: response.softExpressCnpjMeepSub,
    SoftExpressStoreCodeMeepSub: response.softExpressStoreCodeMeepSub,
    SoftExpressIsPagSeguroSubAcquirer: response.softExpressIsPagSeguroSubAcquirer,
    SoftExpressOwnerName: owner?.name,
    SoftExpressOwnerAddress: owner?.address,
    SoftExpressOwnerCity: owner?.city,
    SoftExpressOwnerUf: owner?.uf,
    SoftExpressOwnerCountry: owner?.country,
    SoftExpressOwnerZipCode: owner?.zipCode,
    SoftExpressOwnerMcc: owner?.mcc,
    SoftExpressOwnerCnpjCpf: owner?.cnpjCpf,
    SoftExpressOwnerTelephone: owner?.telephone,
    SoftExpressOwnerMerchantId: owner?.merchantId,
    SoftExpressOwnerFullName: owner?.fullName,
    SoftExpressOwnerDocType: owner?.docType,
    SoftExpressOwnerFacilitatorMerchantId: owner?.facilitatorMerchantId,
  };
};
